import { render, staticRenderFns } from "./entity.vue?vue&type=template&id=85ab3310&"
import script from "./entity.vue?vue&type=script&lang=js&"
export * from "./entity.vue?vue&type=script&lang=js&"
import style0 from "./entity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports